// SessionWarningModal.jsx
import React from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    Stack
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { LsButton } from '../../core';

const SessionWarningModal = ({ open, onContinue, onLogout }) => {
    return (
        <Modal
            open={open}
            onClose={onContinue}
            aria-labelledby="session-warning-title"
            aria-describedby="session-warning-description"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
            }}>
                <Stack spacing={2} alignItems="center">
                    <WarningAmberIcon
                        sx={{ fontSize: 60, color: 'warning.main' }}
                    />

                    <Typography
                        id="session-warning-title"
                        variant="h6"
                        component="h2"
                        textAlign="center"
                    >
                        Session Timeout Warning
                    </Typography>

                    <Typography
                        id="session-warning-description"
                        sx={{ textAlign: 'center' }}
                    >
                        Your session will expire in 2 minutes due to inactivity.
                        Would you like to continue your session?
                    </Typography>

                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <LsButton
                            variant="contained"
                            color="primary"
                            onClick={onContinue}
                        >
                            Continue Session
                        </LsButton>
                        <LsButton
                            variant="outlined"
                            color="error"
                            onClick={onLogout}
                        >
                            Logout Now
                        </LsButton>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default SessionWarningModal;